import { Children } from "react";
import { BantelENTITY, MaterialesBantelDTO } from "sigo-entities";
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico";
import { useDeleteInventoryBantelOrdersMutation } from "../../shared/Infraestructure/slice";
import { Spinner } from "react-bootstrap";

interface Props {
    row: BantelENTITY
}

export function TableInventory({ row }: Props) {

    const [deleteInventory, { isLoading: isLoadingDeleteInventory }] = useDeleteInventoryBantelOrdersMutation()

    const onDeleteMaterial = async (e: MaterialesBantelDTO) => {
        try {
            await deleteInventory({ id: row._id, codigo: e.ID_StockPersonal, serie: e.invsn }).unwrap()
            AdapterGenerico.createMessage('Información', 'Eliminado!', 'success')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    return (
        <table className='table table-striped' style={{ backgroundColor: 'gray' }}>
            <thead>
                <tr>
                    <th scope='col'>Código</th>
                    <th scope='col'>Descripción</th>
                    <th scope='col' className='text-center'>Cantidad</th>
                    <th scope='col' className='text-center'>Serie</th>
                    <th scope='col' style={{ textAlign: 'center' }}>x</th>
                </tr>
            </thead>
            <tbody>
                {
                    Children.toArray(
                        row.inventory.map(e =>
                            <tr>
                                <td>{e.codigo}</td>
                                <td>{e.descripcion}</td>
                                <td className='text-center'>{e.cantidad.toFixed(2)}</td>
                                <td className='text-center'>{e.invsn}</td>
                                <td
                                    scope='row'
                                    onClick={() => onDeleteMaterial(e)}
                                    style={{ verticalAlign: 'middle', textAlign: 'center' }}
                                >
                                    {
                                        isLoadingDeleteInventory ? (
                                            <Spinner animation='border' size='sm' />
                                        ) : (
                                            <i className='fa-solid fa-trash' style={{ fontSize: 15, color: 'red' }} />
                                        )
                                    }
                                </td>
                            </tr>
                        )
                    )
                }
            </tbody>
        </table>
    )
}